import {
  CREATE_PURCHASE_ORDERS_REQUEST,
  CREATE_PURCHASE_ORDERS_SUCCESS,
  CREATE_PURCHASE_ORDERS_ERROR,
  RESET_CREATE_PURCHASE_ORDER,
} from "redux/actions/action-type";

const initialState = {
  isCreatePOLoading: false,
  isCreatePOSuccess: false,
  isCreatePOError: false,
  createPOResponse: [],
  errorDetails: {},
};

const createPOReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case CREATE_PURCHASE_ORDERS_REQUEST:
      return {
        ...state,
        isCreatePOLoading: true,
        isCreatePOSuccess: false,
        isCreatePOError: false,
        createPOResponse: [],
      };

    case CREATE_PURCHASE_ORDERS_SUCCESS:
      return {
        ...state,
        isCreatePOLoading: false,
        isCreatePOSuccess: true,
        isCreatePOError: false,
        createPOResponse: payload,
        errorDetails: {},
      };

    case CREATE_PURCHASE_ORDERS_ERROR:
      return {
        ...state,
        isCreatePOLoading: false,
        isCreatePOSuccess: false,
        isCreatePOError: true,
        createPOResponse: [],
        errorDetails: payload,
      };

    case RESET_CREATE_PURCHASE_ORDER:
      return initialState;

    default:
      return state;
  }
};

export default createPOReducer;
